module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "frontmatter",
      "id": "glo",
      "title": "GLOSSARY"
    }
  }, [_c('header', [_c('h2', {
    staticClass: "h2ft"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_viii",
      "title": "viii"
    }
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_ix",
      "title": "ix"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/nav#rglo"
    }
  }, [_c('i', [_vm._v("Glossary")])])])])])]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('i', [_vm._v("ab im kopp:")]), _vm._v(" crazy, crazy in the head")]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('i', [_vm._v("ach:")]), _vm._v(" oh")]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('i', [_vm._v("aenti:")]), _vm._v(" aunt")]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('i', [_vm._v("appeditlich:")]), _vm._v(" delicious")]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('i', [_vm._v("bruder:")]), _vm._v(" brother")]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('i', [_vm._v("bu/buwe:")]), _vm._v(" boy/boys")]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('i', [_vm._v("daag/daags:")]), _vm._v(" day/days")]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('i', [_vm._v("daed:")]), _vm._v(" father")]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('i', [_vm._v("danki:")]), _vm._v(" thank you")]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('i', [_vm._v("dawdi haus:")]), _vm._v(" smaller home, attached to or near the main house")]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('i', [_vm._v("Dietsch:")]), _vm._v(" Amish language")]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('i', [_vm._v("dochder:")]), _vm._v(" daughter")]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('i', [_vm._v("dumm:")]), _vm._v(" dumb")]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('i', [_vm._v("dummkopf:")]), _vm._v(" idiot")]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('i', [_vm._v("Englisch:")]), _vm._v(" non-Amish")]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('i', [_vm._v("familye:")]), _vm._v(" family")]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('i', [_vm._v("frau:")]), _vm._v(" woman, Mrs.")]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_x",
      "title": "x"
    }
  }, [_c('i', [_vm._v("geh:")]), _vm._v(" go")])]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('i', [_vm._v("gut:")]), _vm._v(" good")]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('i', [_vm._v("gute nacht:")]), _vm._v(" good night")]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('i', [_vm._v("haus:")]), _vm._v(" house")]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('i', [_vm._v("kaffee:")]), _vm._v(" coffee")]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('i', [_vm._v("kapp:")]), _vm._v(" white hat worn by Amish women")]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('i', [_vm._v("kinn/kinner:")]), _vm._v(" child/children")]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('i', [_vm._v("maedel:")]), _vm._v(" girl/young woman")]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('i', [_vm._v("mamm:")]), _vm._v(" mom")]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('i', [_vm._v("mann:")]), _vm._v(" Amish man")]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('i', [_vm._v("mei:")]), _vm._v(" my")]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('i', [_vm._v("mudder/mutter:")]), _vm._v(" mother")]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('i', [_vm._v("nee:")]), _vm._v(" no")]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('i', [_vm._v("nix:")]), _vm._v(" nothing")]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('i', [_vm._v("onkel:")]), _vm._v(" uncle")]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('i', [_vm._v("schee:")]), _vm._v(" pretty/handsome")]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('i', [_vm._v("schwesters:")]), _vm._v(" sisters")]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('i', [_vm._v("seltsam:")]), _vm._v(" weird")]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('i', [_vm._v("sohn:")]), _vm._v(" son")]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('i', [_vm._v("vatter:")]), _vm._v(" father")]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('i', [_vm._v("ya:")]), _vm._v(" yes")]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('i', [_vm._v("yer:")]), _vm._v(" your")]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('i', [_vm._v("yerself:")]), _vm._v(" yourself")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c3510272","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/9780718082536_Glossary.vue
// module id = 75
// module chunks = 0